import {apiFetch} from 'lib/fetch'
import type {ListOrganizer, Organizer} from 'types/department'
import {getApiUrl} from '../urls'

export const list = async (): Promise<ListOrganizer[]> =>
  apiFetch.get<ListOrganizer[]>(getApiUrl('organizers'), {simple: 'true'})

export const show = async (id: number): Promise<Organizer> =>
  apiFetch.get<Organizer>(getApiUrl('organizers', id))
